import styled from 'styled-components'
import SiteMessageForm from 'pages/shared/SiteMessageForm'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'

const AddSiteMessage = () => (
  <>
    <PageHeader>
      <S.PageTitle>New Site Message</S.PageTitle>
    </PageHeader>
    <S.SinglePanePage>
      <SiteMessageForm
        validatedSaveType="create"
      />
    </S.SinglePanePage>
  </>
)

export default AddSiteMessage

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
